<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <div>
                打款日：<el-date-picker style="width: 120px" @change="refetchData" v-model="paymentDate" type="month"
                    range-separator="至" start-placeholder="开始" end-placeholder="结束" size="mini"
                    :clearable="false"></el-date-picker>
            </div>
            <el-button class="margin-l" size="mini" type="primary" @click.stop="refetchData"
                :loading="loading">搜索</el-button>
            <el-button class="margin-l" size="mini" type="warning" @click.stop="exportXlsx()">导出Excel</el-button>
        </div>

        <paged-table class="block-mini-top" :page-size="1000" ref="table" @fetch-data="fetchData">
            <el-table show-summary :summary-method="getSummaries" @filter-change="handleFilter" slot :data="data" border
                size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="45"></el-table-column>
                <el-table-column label="打款日" align="center" width="110">
                    <template slot-scope="scope" v-if="scope.row.paymentDate">
                        {{ scope.row.paymentDate | fmt-date }}
                    </template>
                </el-table-column>
                <el-table-column :filters="admins" :filter-multiple="false" column-key="admin" label="销售" prop="admin"
                    align="center" width="90">
                </el-table-column>
                <el-table-column label="受益人" align="center" width="120">
                    <template slot-scope="scope" v-if="scope.row.user">
                        {{ scope.row.user.name }}
                    </template>
                </el-table-column>
                <el-table-column label="投资额(万元)" align="center" width="90">
                    <template slot-scope="scope" v-if="scope.row.amount">
                        {{ scope.row.amount / 10000 }}
                    </template>
                </el-table-column>
                <el-table-column label="产品名称" prop="title" align="center" width="350">
                    <template slot-scope="scope">
                        <span>{{ scope.row.good && scope.row.good.category ? scope.row.good.category : "无分类"}}</span> -
                        <span>{{ scope.row.good && scope.row.good.title ? scope.row.good.title : scope.row.title}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="产品期限(年)" align="center" width="60" prop="term"></el-table-column>
                <el-table-column label="折算业绩" align="center" width="90" prop="convert"></el-table-column>
                <el-table-column label="基点" align="center" width="70">
                    <template slot-scope="scope">
                        <span>{{scope.row.good && scope.row.good.basePoint ? scope.row.good.basePoint :"无"}} </span>
                        <span class="color-success font-bold"
                            :style="pointAddStyle(scope.row)">+{{ scope.row.pointAdd }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="利润" align="center" width="90" prop="profit"></el-table-column>
            </el-table>
        </paged-table>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";
import { exportExcel } from "../util/exportExcel";

import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";

export default {
    components: {
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            loading: false,
            admin: "",
            admins: [],
            paymentDate: dayjs().startOf("month"),
        };
    },
    created() {
        this.fetchAdmins();
    },
    mounted() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() {},
    methods: {
        async exportXlsx() {
            await actionConfirm();
            let list = this.data.map((it) => {
                return {
                    打款日: it.paymentDate
                        ? dayjs(it.paymentDate).format("YYYY-MM-DD")
                        : "",
                    销售: it.admin ? it.admin : "",
                    受益人: it.user && it.user.name ? it.user.name : "",
                    "投资额(万元)": it.amount ? it.amount / 10000 : "",
                    产品名称:
                        (it.good && it.good.category
                            ? it.good.category
                            : "无分类") +
                        " - " +
                        (it.good && it.good.title ? it.good.title : it.title),
                    "产品期限(年)": it.term ? it.term : "",
                    折算业绩: it.convert ? it.convert : "",
                    基点:
                        (it.good && it.good.basePoint
                            ? it.good.basePoint
                            : "无") +
                        " +" +
                        (it.pointAdd ? it.pointAdd : "") +
                        (it.good.category.includes("信托")
                            ? "(信托，去掉+)"
                            : ""),
                    利润: it.profit ? it.profit : "",
                };
            });
            exportExcel(
                list,
                dayjs().format("YYYY-MM-DD_HH:mm:ss") +
                    `_${this.data.length}` +
                    "_计算.xlsx"
            );
        },
        //如果是信托，不计算基点加成
        pointAddStyle(item) {
            if (item.good.category.includes("信托")) {
                return "text-decoration:line-through";
            } else {
                return "";
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }
                // const values = data.map((item) =>
                //     Number(item[column.property])
                // );
                // if (!values.every((value) => isNaN(value))) {
                //     sums[index] = values.reduce((prev, curr) => {
                //         const value = Number(curr);
                //         if (!isNaN(value)) {
                //             return prev + curr;
                //         } else {
                //             return prev;
                //         }
                //     }, 0);
                //     sums[index] += " 元";
                // } else {
                //     sums[index] = "N/A";
                // }
                if (column.label.includes("投资额")) {
                    let total = 0;
                    data.forEach((it) => {
                        total += it.amount / 10000;
                    });
                    sums[index] = total + " 万";
                }
                if (column.label == "折算业绩") {
                    let total = 0;
                    data.forEach((it) => {
                        total += it.convert;
                    });
                    sums[index] = total;
                }
                if (column.label == "利润") {
                    let total = 0;
                    data.forEach((it) => {
                        total += it.profit;
                    });
                    sums[index] = total;
                }
            });

            return sums;
        },
        async fetchAdmins() {
            let res = await HttpClient.post("/admin/getAll");
            this.admins = res.map((it) => {
                return { text: it.description, value: it.description };
            });
        },
        handleFilter(column) {
            if (column.admin) {
                if (column.admin.length) {
                    this.admin = column.admin[0];
                } else {
                    this.admin = "";
                }
            }
            this.refetchData();
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
            };
            if (this.admin) {
                cond = { ...cond, admin: this.admin };
            }
            if (this.paymentDate) {
                cond = {
                    ...cond,
                    paymentDate: {
                        $gte: dayjs(this.paymentDate).startOf("month"),
                        $lte: dayjs(this.paymentDate).endOf("month"),
                    },
                };
            }

            this.loading = true;
            let res = await HttpClient.post("/order/getPay", cond);
            this.loading = false;
            if (!res.result) msgError(res.msg);
            this.totalAmount = res.totalAmount ? res.totalAmount : 0;
            this.data = res.result;
            this.table.submitTotal(res.count);
        },
    },
};
</script>
